export default class SwapPage {
    constructor() {
    }
    swapPage(pageId) {
        var pages = document.getElementsByClassName("page");
        for (var i = 0; i < pages.length; i++) {
            let page = pages[i];
            //page.style.display = "none";
            //todo: add class hidden
            page.classList.remove("activePage");
            //page.classList.add("pageHidden");
        }
        var page = document.getElementById(pageId);
        if (page) {
            //page.style.display = "block";
            //todo: remove class hidden
            //page.classList.remove("pageHidden");
            page.classList.add("activePage");
        }
        window.scrollTo(0, 0);

    }
}